/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Subject,
    SubjectFromJSON,
    SubjectFromJSONTyped,
    SubjectToJSON,
} from './Subject';

/**
 * 
 * @export
 * @interface EAFSGArea
 */
export interface EAFSGArea {
    /**
     * 
     * @type {string}
     * @memberof EAFSGArea
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof EAFSGArea
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof EAFSGArea
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof EAFSGArea
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EAFSGArea
     */
    description?: string | null;
    /**
     * 
     * @type {Array<Subject>}
     * @memberof EAFSGArea
     */
    subjects?: Array<Subject> | null;
}

export function EAFSGAreaFromJSON(json: any): EAFSGArea {
    return EAFSGAreaFromJSONTyped(json, false);
}

export function EAFSGAreaFromJSONTyped(json: any, ignoreDiscriminator: boolean): EAFSGArea {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'subjects': !exists(json, 'subjects') ? undefined : (json['subjects'] === null ? null : (json['subjects'] as Array<any>).map(SubjectFromJSON)),
    };
}

export function EAFSGAreaToJSON(value?: EAFSGArea | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'name': value.name,
        'description': value.description,
        'subjects': value.subjects === undefined ? undefined : (value.subjects === null ? null : (value.subjects as Array<any>).map(SubjectToJSON)),
    };
}

